import React, { useEffect, useState } from "react";
import { Alert, Spinner } from "reactstrap";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";

import axios from "../../helpers/axiosConfig";
import { setToken } from "../../slices/authSlice";
import ParticlesAuth from "./ParticlesAuth";

const EmailVerified = () => {
  const [searchParams] = useSearchParams();
  const [status, setStatus] = useState<"checking" | "verified" | "unverified" | "error">(
    "checking",
  );
  const [message, setMessage] = useState<string>("");
  const navigate = useNavigate();
  const dispatch = useDispatch();

  useEffect(() => {
    document.title = "Hệ thống quản lý đặt món - Xác minh email";
  }, []);

  useEffect(() => {
    let isMounted = true;

    const verificationStatus = searchParams.get("status");
    if (verificationStatus && verificationStatus !== "verified") {
      setStatus("error");
      setMessage("Liên kết xác minh không hợp lệ hoặc đã hết hạn.");
      return;
    }

    const verifyUser = async () => {
      try {
        const response = await axios.get("/api/user", { withCredentials: true });
        const responseData = response?.data ?? response;
        const userData = responseData?.user ?? responseData;

        if (!userData) {
          if (isMounted) {
            setStatus("error");
            setMessage("Không thể xác nhận người dùng. Vui lòng đăng nhập lại.");
          }
          return;
        }

        if (userData.email_verified_at) {
          const session = { user: userData };
          localStorage.setItem("authUser", JSON.stringify(session));
          dispatch(setToken(session));
          if (isMounted) {
            setStatus("verified");
          }
          navigate("/order", { replace: true });
        } else {
          if (isMounted) {
            setStatus("unverified");
            setMessage("Email của bạn chưa được xác minh. Vui lòng kiểm tra hộp thư.");
          }
          navigate("/verify-email", { replace: true });
        }
      } catch (error: any) {
        if (isMounted) {
          const statusCode = error?.response?.status ?? error?.status;
          let errorMessage = "Liên kết xác minh không hợp lệ hoặc đã hết hạn.";

          if (statusCode === 401 || statusCode === 419) {
            errorMessage = "Phiên đăng nhập đã hết hạn. Vui lòng đăng nhập lại.";
          }

          setStatus("error");
          setMessage(errorMessage);
        }
      }
    };

    verifyUser();

    return () => {
      isMounted = false;
    };
  }, [dispatch, navigate, searchParams]);

  return (
    <ParticlesAuth>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-10 col-lg-8">
            <div className="text-center text-white mb-4">
              <h2>Đang xác minh email</h2>
              <p className="text-white-50 mb-0">
                Chúng tôi đang kiểm tra trạng thái xác minh của bạn.
              </p>
            </div>

            {status === "checking" && (
              <div className="bg-white rounded p-4 text-center">
                <Spinner size="sm" className="me-2" />
                Đang xác minh...
              </div>
            )}

            {status !== "checking" && status !== "verified" && (
              <div className="bg-white rounded p-4">
                <Alert color="danger" className="mb-3">
                  {message}
                </Alert>
                <div className="d-flex flex-column gap-2">
                  <Link className="btn btn-warning" to="/verify-email">
                    Gửi lại email xác minh
                  </Link>
                  <Link className="btn btn-outline-secondary" to="/login">
                    Quay lại đăng nhập
                  </Link>
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </ParticlesAuth>
  );
};

export default EmailVerified;
